import React from 'react';
import { Advertisement } from '@/components/Icons/Advertisement';
import { Alert } from '@/components/Icons/Alert';
import { ArrowLeft } from '@/components/Icons/ArrowLeft';
import { Bell } from '@/components/Icons/Bell';
import { BellRinging } from '@/components/Icons/BellRinging';
import { Chat } from '@/components/Icons/Chat';
import { CheckCircle } from '@/components/Icons/CheckCircle';
import { ChevronDown } from '@/components/Icons/ChevronDown';
import { ChevronRight } from '@/components/Icons/ChevronRight';
import { Close } from '@/components/Icons/Close';
import { Father } from '@/components/Icons/Father';
import { Group } from '@/components/Icons/Group';
import { Lock } from '@/components/Icons/Lock';
import { Logout } from '@/components/Icons/Logout';
import { Mail } from '@/components/Icons/Mail';
import { Mother } from '@/components/Icons/Mother';
import { Person } from '@/components/Icons/Person';
import { Phone } from '@/components/Icons/Phone';
import { Return } from '@/components/Icons/Return';
import { PlusSign } from '@/components/Icons/PlusSign';
import { Student } from '@/components/Icons/Student';
import { Subscription } from '@/components/Icons/Subscription';
import { Support } from '@/components/Icons/Support';
import {
  ContrastIcon,
  MoonIcon,
  SunIcon,
  SystemIcon,
} from '@/components/Icons/SidebarIcons';
import { HelpFilled } from '@/components/Icons/HelpFilled';
import { LinkSmall } from '@/components/Icons/LinkSmall';
import { PartnersFilled } from '@/components/Icons/PartnersFilled';
import { IconType, type IconComponentProps } from '@/types/components';

interface Props {
  icon: IconType;
  className?: string;
}

const iconComponents: Record<IconType, React.FC<IconComponentProps>> = {
  [IconType.Logout]: Logout,
  [IconType.PlusSign]: PlusSign,
  [IconType.Close]: Close,
  [IconType.ArrowLeft]: ArrowLeft,
  [IconType.Return]: Return,
  [IconType.ChevronRight]: ChevronRight,
  [IconType.ChevronDown]: ChevronDown,
  [IconType.CheckCircle]: CheckCircle,
  [IconType.Alert]: Alert,
  [IconType.Support]: Support,
  [IconType.Chat]: Chat,
  [IconType.Mother]: Mother,
  [IconType.Father]: Father,
  [IconType.Student]: Student,
  [IconType.Person]: Person,
  [IconType.Phone]: Phone,
  [IconType.Mail]: Mail,
  [IconType.Lock]: Lock,
  [IconType.Group]: Group,
  [IconType.Bell]: Bell,
  [IconType.BellRinging]: BellRinging,
  [IconType.Subscription]: Subscription,
  [IconType.Advertisement]: Advertisement,
  [IconType.Partners]: PartnersFilled,
  [IconType.Link]: LinkSmall,
  [IconType.Help]: HelpFilled,
  [IconType.ThemeLight]: SunIcon,
  [IconType.ThemeDark]: MoonIcon,
  [IconType.ThemeContrast]: ContrastIcon,
  [IconType.ThemeSystem]: SystemIcon,
};

export const Icon: React.FC<Props> = ({ icon, className }) => {
  const IconComponent = iconComponents[icon];

  return <IconComponent className={className} />;
};
